<script setup lang="ts">
import { ComponentStripeTextCardProps } from "./ComponentStripeTextCard.props"
import {
  CounterTheme,
  CounterType,
  SizeClass
} from "~/components/Molecules/Counter.props"

const props = withDefaults(defineProps<ComponentStripeTextCardProps>(), {
  text: "",
  countDownInHours: false,
  showFeedatySummary: false
})

const counter = computed(() => {
  const setting = {
    isVisible: false,
    counterDate: undefined
  }
  if (props.relatedPromotion) {
    const date = props.teaser
      ? props.relatedPromotion.startDate
      : props.relatedPromotion.endDate

    const now = new Date()
    const endCounterDate = new Date(date)
    const isVisible = endCounterDate.getTime() - now.getTime() > 0

    setting.isVisible = isVisible
    setting.counterDate = isVisible && date
  }

  return setting
})
</script>

<template>
  <div class="flex flex-row items-center justify-center gap-3">
    <FeedatyReviewsSummary v-if="showFeedatySummary" />

    <UtilsMarkdown
      v-if="text"
      :content="text"
      class="
        mouse-bold
        markdown__link-underlined markdown__link-mouse-medium
        line-clamp-2
      "
    />

    <MoleculesCounter
      v-if="counter.isVisible"
      :date="counter.counterDate"
      :countDownInHours="countDownInHours"
      :theme="CounterTheme.text"
      :type="CounterType.justTime"
      :sizeClass="SizeClass.mouse"
      separator=":"
      gap="1"
    />
  </div>
</template>
